import { useEffect, useState } from "react";

// Tailwind breakpoints
type Breakpoint = "sm" | "md" | "lg" | "xl" | "2xl";

export function useDeviceWidth(): Breakpoint | undefined {
  const [breakpoint, setBreakpoint] = useState<Breakpoint | undefined>(
    undefined,
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const getBreakpoint = (): Breakpoint | undefined => {
      const width = window.innerWidth;
      if (width >= 1536) return "2xl";
      if (width >= 1280) return "xl";
      if (width >= 1024) return "lg";
      if (width >= 768) return "md";
      if (width >= 640) return "sm";
      return undefined;
    };

    setBreakpoint(getBreakpoint());

    const handleResize = () => setBreakpoint(getBreakpoint());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoint;
}

export function useBreakpoint(
  breakpoints: Partial<Record<Breakpoint | "default", number>>,
): number | undefined {
  const deviceWidth = useDeviceWidth();

  return deviceWidth ? breakpoints[deviceWidth] || breakpoints.default : breakpoints.default;
}
